import { Card } from '@mui/material';
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SelectField,
  ArrayField,
  SingleFieldList,
  SelectInput,
  ArrayInput,
  usePermissions,
} from 'react-admin';

import { boldDataGridStyle } from '../../constants/style/datagridStyles';

import ColoredScoreField from '../../customFields/ColoredScoreField';

import NoResults from '../layout/NoResults';
import Pagination from '../layout/Pagination';
import LinkField from '../layout/LinkField';

import countries from '../../constants/countries';
import ChipStringField from '../../customFields/ChipStringField';
import { ReferenceManyDisplayField } from '../../customFields/EditReferenceManyField';
import SearchField from '../../customFields/SearchField';
import hasAccess from '../../utilities/hasAccess';
import actions, { Actions } from '../../constants/actions';
import GroupFilter from '../utils/GroupFilter';

export const BusinessListBody = ({ children }: {children?: React.ReactElement}) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Datagrid sx={boldDataGridStyle} bulkActionButtons={false} empty={<NoResults variant="h6" />}>
      {hasAccess(permissions, actions.BUSINESS_GET) ? (
        <LinkField sortable={false} source="id" label="ID" />
      ) : (
        <TextField sortable={false} source="id" label="ID" />
      )}
      <ArrayField sortable={false} source="customIds" label="Custom IDs">
        <SingleFieldList linkType={false}>
          <ChipStringField />
        </SingleFieldList>
      </ArrayField>
      {hasAccess(permissions, actions.GROUP_LIST) && (
        <ReferenceManyDisplayField
          sortable
          label="Groups"
          reference="groups"
          source="groups"
        />
      )}
      <TextField sortable={false} source="name" />
      <TextField sortable={false} source="registrationNumber" />
      <SelectField sortable source="residence" label="Registration country" choices={countries} />
      <ColoredScoreField source="riskScore" />
      {children}
    </Datagrid>
  );
};

export const getBusinessFilters = ({
  hideSearch = false,
}) => [
  ...(hideSearch ? [] : [<SearchField source="search" label="Search" alwaysOn />]),
  <SelectInput
    label="Registration country"
    source="residence"
    choices={countries}
  />,
  <ArrayInput source="groups" label="Groups">
    <GroupFilter />
  </ArrayInput>,
];

const BusinessFilters = getBusinessFilters({});

const BusinessList = () => (
  <List
    filters={BusinessFilters}
    sort={{ field: 'createdAt', order: 'DESC' }}
    empty={false}
    pagination={<Pagination disableEmptyText />}
    exporter={false}
    perPage={50}
  >
    <Card sx={{ margin: 0 }} variant="outlined">
      <BusinessListBody />
    </Card>
  </List>
);

export default BusinessList;
